import NumberFlow from '@number-flow/react'
import continuous from '@number-flow/react'
import {useUserStateProvider} from '../../../../app/utils/contextProvider/UserStateProvider'
import clsx from 'clsx'

const Balance = () => {
  const {balance} = useUserStateProvider()

  if (!balance) return <></>

  return (
    <div className='d-flex gap-0 align-items-center mt-1'>
      {balance.balance < 1000 && (
        <a
          href='#'
          className='btn btn-icon btn-transparent pulse pulse-danger fs-3 text-danger ms-3'
        >
          <i className='bi bi-cash fs-1 text-danger'></i>
          <span className='pulse-ring border-2'></span>
        </a>
      )}
      <span
        className={clsx(
          'fs-3 fw-bold m-0',
          balance.balance < 1000 ? 'text-danger' : 'text-gray-800'
        )}
      >
        &#2547;
        {/* {balance.balance}{' '} */}
        <NumberFlow willChange plugins={[continuous]} value={balance.balance} locales='en-US' />
      </span>
    </div>
  )
}

export default Balance
